export const PDF_MIME_TYPE = "application/pdf";
export const ACCEPT_TYPE = ".pdf";
export const EXTRACT_START = "Iniciar Extração";
export const STARTING_EXTRACTION = "Iniciando extração...";
export const DOWNLOAD_AGAIN = "Baixar ZIP novamente";
export const B_UNIT = "B"
export const KB_UNIT = "KB"
export const MB_UNIT = "MB"
export const GB_UNIT = "GB"
export const MAX_FILE = 50;
export const MAX_FILE_SIZE_BYTES = 10 * 1024 * 1024;